import { createSlice } from "@reduxjs/toolkit";

const initialRootState: { data: boolean } = {
  data: true,
};

export const RootPageRenderSlice = createSlice({
  name: "RootPageRenderSlice",
  initialState: initialRootState,
  reducers: {
    updateRootPageRenderState: (state, action) => {// call when entering to root page 
      state.data = action.payload;
    },
  },
});

export const { updateRootPageRenderState } =
  RootPageRenderSlice.actions;

